import timezone from 'moment-timezone';
import moment from 'moment'

const getFirstParagraph = ({ organization, client, sessionDate }) => {
  const TIMEZONE = timezone.tz.guess() || 'America/New_York'; // guess users time zone
  const date = sessionDate
    ? timezone(sessionDate)
      .tz(TIMEZONE)
      .format('dddd, MMMM D YYYY')
    : '';
  return `
      <p>
        This Contract is between ${client.firstName} ${client.lastName} (the "Client")
        and ${organization.title} (the "Photographer") for
        photography work on ${date || moment().format('M/D/YY')}.
      </p>
    `;
};

export default getFirstParagraph;



// WEBPACK FOOTER //
// ./src/lib/helpers/TextEditorHelpers/getFirstParagraph.js